import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { NombreLog } from './nombre-log.entity';

@Entity('pion_nombre_log')
export class PionNombreLog {
    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    pour_qui: string; // séparé par ;

    @Column()
    qui_a_vu_quand: string; // peut-être utile dans le futur

    @Column()
    diffuse: boolean;

    @Column()
    fk_nombre_log: number;

    @ManyToOne(() => NombreLog)
    @JoinColumn({ name: 'fk_nombre_log', referencedColumnName: 'id' })
    nombreLog: NombreLog;
}
